/* eslint-disable */
import axios from 'axios';
import config from '@assets/config.json'; // api 请求json  
// 通用 Module 
const state = {
  searchType: 0, // 搜索类型, 0 产品； 1 展商
  searchContent: "", // 导航中搜索内容
  caId: "", // 导航栏传的产品分类Id
}
const mutations = {
  setSearchType(state, data) {
    state.searchType = data;
  },
  setSearchContent(state, data) {
    state.searchContent = data;
  },
  setCaId(state, data) {
    state.caId = data;
  },
}
const getters = {
  getSearchType: state => {
    return state.searchType;
  },
  getSearchContent: state => {
    return state.searchContent;
  },
  getCaId: state => {
    return state.caId;
  }
}
const actions = {
  getProduct({ rootState }, opt) { // 获取产品
    // 获取产品排行榜([{Topic说明\":\"-1:所有，0:Normal=不置顶，1:Hot=热门，2:Recommend=推荐"}] )
    // apply 0:全部 ; 1免费体验； -1不能体验
    //canApply 0体验已经过期 ；1没过期；
    return new Promise((resolve, reject) => { 
      axios.post(`${config.api.reqApi}/api/product/GetByExhibition?topic=${opt.topic}&apply=${opt.apply}`, opt.body, rootState.header).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getProductCategory({ rootState }, id) { // 获取云店标签
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/Category/ByGroupId?level=0`, rootState.header).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

    getActionType ({ rootState }, id) { // 获取展会下的产品类别
    return new Promise((resolve, reject) => {
        axios.get(`${config.api.reqApi}/api/actionType/GetList?typeId=5`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
//   getProductCategory({ rootState }, id) { // 获取展会下的产品类别
//     return new Promise((resolve, reject) => {
//       axios.get(`${config.api.reqApi}/api/category/GetAndListByExhibition?exhibitionId=${id}`, rootState.header).then(data => {
//         if (data.data && data.status === 200) {
//           resolve(data.data);
//         } else {
//           resolve(null);
//         }
//       }).catch((err) => {
//         console.log(err);
//       });
//     });
//   },


  getRanking({ rootState }, opt) { // 获取展商
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/join/GetByExhibition?show=1&userId=${rootState.user ? rootState.user.userId : null}&modeType=-10`, opt, rootState.header ).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getExhibitionPlan({ rootState }) { // 获取展会计划
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/ExhibitionPlan/GetList` ).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getExhibitionPlanById({ rootState }, id) { // 根据id获取品牌展会
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/ExhibitionPlan?id=${id}` ).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 供需对接页面
  getReleaseType({ rootState }, opt) { // 获取分类的供需
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/ReleaseType/GetReleases?exhibitionId=${opt.exhibitionId}&top=${opt.top}` ).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getReleaseByTypeId({ rootState }, opt) { // 根据供需的分类Id获取
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Release/GetShortByTypeId`, opt ).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
//   产品抽奖
  getProductIsWin({ rootState }, opt) { 
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/LuckyDraw/SearchKey`, opt ).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
    },
  
  
    //   获取所有展会
    getAllExList ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.api.reqApi}/api/exhibition/GetByAgent`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }

            }).catch((err) => {
                console.log(err);
            });
        });
    },

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 